<app-lfsa-card [innTemplate]="buscador" [titulo]="'BUSCAR'" [efecto]="true" [colapseName]="'buscador'"
  [banderaColapse]='true'></app-lfsa-card>
<ng-template #buscador>
  <form [formGroup]="formularioBuscador" novalidate class="form-group">
    <div class="row">
      <div class="'col-md-4'">
        <app-lfsa-combo-box (change)="getEmpleadoByEmpresa()" [claseLabel]="'letrasDanger'" [opcion]="'descripcion'"
          [idOpcion]="'codEmpresa'" [comboBox]="cmbEmpresas" formControlName="codEmpresa"
          [control]="formularioBuscador.get('codEmpresa')" [label]="'Empresas*'" [id]="'descripcion'">
        </app-lfsa-combo-box>
      </div>
    </div>
  </form>
  <br>
</ng-template>

<app-lfsa-card [innTemplate]="datosDesvinculacion" [titulo]="'PERSONA A DESVINCULAR'" [efecto]="true"
  [colapseName]="'datosDesvinculacion'" [banderaColapse]='true'></app-lfsa-card>
<ng-template #datosDesvinculacion>

  <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
  <div *ngIf="!loading">
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
      No existen datos para la lista de Reporte.
    </div>
    <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{empModulo.agGrid.class}}"
      [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
      [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)" [floatingFilter]="true"
      [pagination]="false" [paginationPageSize]=15>
    </ag-grid-angular>
  </div>
  <br>
</ng-template>

<app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
<div *ngIf="!loading" class="row">
  <div class="form-group col-md-12">
    <button [routerLink]="['/emp/administrador/home-emp']"
      class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
  </div>
</div>

<app-lfsa-modal [innTemplate]="modalBody" [titulo]="'Desvincular Colaborador'" [idButton]="'abrirModal'" [idOpen]="'modalAbrir'" [idClose]="'cerrar'">
</app-lfsa-modal>
<ng-template #modalBody>
  <form [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-md-12">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" (change)="getDepartamentoByEmpresa()" [opcion]="'descripcion'"
          [idOpcion]="'codEmpresa'" [comboBox]="cmbEmpresaSolicita" formControlName="empresaSolicita"
          [control]="formulario.get('empresaSolicita')" [label]="'Empresa Solicitante*'" [id]="'empresaSolicita'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-12">
        <app-lfsa-combo-box [opcion]="'descripcion'" [claseLabel]="'letrasDanger'" (change)="selecionDepartamentoSolicita()"
          [idOpcion]="'id'" [comboBox]="cmbDepartamentoSolicita" formControlName="departamentoSolicita"
          [control]="formulario.get('departamentoSolicita')" [label]="'Departamento'" [id]="'departamentoSolicita'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-12">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombres'" [idOpcion]="'cedula'"
          [comboBox]="cmbSolicitante" formControlName="codSolicitante" [control]="formulario.get('codSolicitante')"
          [label]="'Solicitante*'" [id]="'codSolicitante'">
        </app-lfsa-combo-box>
      </div>
      <div class="'col-md-12'">
        <label for="" class="letrasDanger">Observación</label>
        <textarea placeholder="Observación" class="form-control rounded-0" rows="2" formControlName="observacion"
          maxlength="200"></textarea>
        <app-lfsa-error-msg [control]="formulario.get('observacion')" [label]="'Observación'"></app-lfsa-error-msg>
      </div>
    </div>
    <hr>
    <!-- {{ formulario.value | json }} -->
    <div class="row">
      <div class="form-group col-md-12">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <button *ngIf="!loading" (click)="desvincularEmpleado()" [disabled]="formulario.invalid"
          class="btn btn-primary btn-block">Desvincular</button>
      </div>
    </div>
  </form>
</ng-template>